/**
Author - Babajan Patan
Git - https://github.com/babajanpatan
* */

import Checkbox from "./Checkbox.container";

export default Checkbox;
